"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeout = void 0;
const sleep_1 = require("./sleep");
/**
 * Will wait for the given promise, but will timeout after the given `timeoutMs` exceeds,
 * returning a `TimeoutExceeded` result.
 */
async function timeout(promise, timeoutMs) {
    const timeout = (0, sleep_1.sleep)(timeoutMs).then(() => "timeout-exceeded");
    const result = await Promise.race([promise, timeout]);
    if (result === "timeout-exceeded") {
        return { type: "timeout-exceeded", timeoutMs };
    }
    return { type: "ok", result };
}
exports.timeout = timeout;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGltZW91dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy90aW1lb3V0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1DQUFnQztBQWNoQzs7O0dBR0c7QUFDSSxLQUFLLFVBQVUsT0FBTyxDQUMzQixPQUFtQixFQUNuQixTQUFpQjtJQUVqQixNQUFNLE9BQU8sR0FBRyxJQUFBLGFBQUssRUFBQyxTQUFTLENBQUMsQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLENBQUMsa0JBQTJCLENBQUMsQ0FBQztJQUN6RSxNQUFNLE1BQU0sR0FBRyxNQUFNLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxPQUFPLEVBQUUsT0FBTyxDQUFDLENBQUMsQ0FBQztJQUV0RCxJQUFJLE1BQU0sS0FBSyxrQkFBa0IsRUFBRSxDQUFDO1FBQ2xDLE9BQU8sRUFBRSxJQUFJLEVBQUUsa0JBQWtCLEVBQUUsU0FBUyxFQUFFLENBQUM7SUFDakQsQ0FBQztJQUVELE9BQU8sRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO0FBQ2hDLENBQUM7QUFaRCwwQkFZQyJ9